import { BaseNode, FoblexNode } from '@app/utilities/foblex-flow/base-node/base-node';
import {Node as _Node} from '../../../shared-models/public/node';

export class Node extends _Node{
    public toBaseNode(node: Node): BaseNode {
        const dimension:FoblexNode.Dimension = JSON.parse(node.dimension);
        const baseNode =  new BaseNode(
            node.id,
            dimension.height,
            dimension.width,
            node.resourceId,
            node.type,
            JSON.parse(node.position)
        );  
        return baseNode;
    }
}

export namespace Node{
    export import RestTypes=_Node.RestTypes;
}